export const shippingChargeCents = 1000;
export const freeShippingMinCents = 3000;